import instance from '../xhrService';

export interface AgreementSignability {
  canSignClient: boolean;
  canSignInspector: boolean;
  isReadOnly: boolean;
  canWaive: boolean;
}

export interface AgreementSignerInformation {
  name: string | null;
  title: string | null;
  isSignatureAdded: boolean;
}

export interface Agreement {
  waived_at: string | null;
  waived_by_user_id: number | null;
  id: number;
  project_id: number;
  tenant_id: number;
  status: 'pending' | 'executed';
  client_user_id: number | null;
  client_signed_at: string | null;
  inspector_user_id: number | null;
  inspector_signed_at: string | null;
  pdf_storage_path: string | null;
  client_name: string | null;
  client_title: string | null;
  inspector_name: string | null;
  inspector_title: string | null;
  billing_customer_name: string | null;
  billing_co: string | null;
  billing_address: string | null;
  billing_email_1: string | null;
  billing_email_2: string | null;
  billing_email_3: string | null;
  billing_email_4: string | null;
  billing_phone_number_1: string | null;
  billing_name_1: string | null;
  billing_title_1: string | null;
  billing_phone_number_2: string | null;
  billing_name_2: string | null;
  billing_title_2: string | null;
  billing_phone_number_3: string | null;
  billing_name_3: string | null;
  billing_title_3: string | null;
  billing_additional_info: string | null;
  billing_project_type: string | null;
}

export interface AgreementState {
  required: boolean;
  agreement: Agreement | null;
  signability: AgreementSignability;
  signerInformation: AgreementSignerInformation;
  agreementBodyHtml: string;
}

const authorizationAgreementApi = {
  getAgreement(projectId: number): Promise<AgreementState> {
    return instance
      .get(`/api/projects/${projectId}/authorization-agreement`)
      .then((res) => res.data);
  },

  signBlock(
    projectId: number,
    block: 'client' | 'inspector',
  ): Promise<{ agreement: Agreement }> {
    return instance
      .post(`/api/projects/${projectId}/authorization-agreement/sign`, {
        block,
      })
      .then((res) => res.data);
  },

  waiveRequirement(projectId: number): Promise<{ agreement: Agreement }> {
    return instance
      .post(`/api/projects/${projectId}/authorization-agreement/waive`)
      .then((res) => res.data);
  },

  unwaiveRequirement(
    projectId: number,
  ): Promise<{ agreement: Agreement | null }> {
    return instance
      .delete(`/api/projects/${projectId}/authorization-agreement/waive`)
      .then((res) => res.data);
  },

  saveBilling(
    projectId: number,
    data: Partial<Agreement>,
  ): Promise<{ agreement: Agreement }> {
    return instance
      .patch(`/api/projects/${projectId}/authorization-agreement/billing`, data)
      .then((res) => res.data);
  },

  downloadPdf(projectId: number): Promise<Blob> {
    return instance
      .get(`/api/projects/${projectId}/authorization-agreement/download`, {
        responseType: 'blob',
      })
      .then((res) => res.data);
  },
};

export default authorizationAgreementApi;
